import React, { Dispatch, SetStateAction } from 'react';

import { Button, ButtonOwnProps, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';


interface ConfirmationModalProps {
    open: boolean;
    headTitle: string;
    bodyMessage: string;
    confirmBtnColor?: ButtonOwnProps['color'];
    setOpen: Dispatch<SetStateAction<boolean>>;
    handleSubmit: (isConfirm: boolean) => void;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
    open,
    headTitle,
    bodyMessage,
    confirmBtnColor,
    setOpen,
    handleSubmit,
}) => {

    const handleConfirm = () => {
        handleSubmit(true);
        setOpen(false);
    }

    const handleCancel = () => {
        handleSubmit(false);
        setOpen(false);
    }

    return (
        <Dialog
            open={open}
            onClose={() => setOpen(false)}
            aria-labelledby="confirmation-dialog-title"
            aria-describedby="confirmation-dialog-description"
        >
            <DialogTitle id="confirmation-dialog-title">
                {headTitle}
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="confirmation-dialog-description">
                    {bodyMessage}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button variant='outlined' onClick={handleCancel}>Cancel</Button>
                <Button color={confirmBtnColor || 'primary'} variant='outlined' onClick={handleConfirm} autoFocus>
                    Confirm
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default ConfirmationModal